export const FORMAT_PRICE = {
  integer: 'integer',
  decimal: 'decimal',
}

export const DEFAULT_FORMAT_PRICE = 'integer'
